import ModalHeader from '../ModalHeader/ModalHeader'
import CustomTextArea from '../UI/CustomTextArea/CustomTextArea'
import styles from './CreateCommentModal.module.css'
import { Form, Formik } from 'formik'
import IconTrashRed from '../../assets/icons/IconTrashRed.svg'
import CustomButton from '../UI/CustomButton/CustomButton'
import { useAppDispatch } from '../../redux/types/types'
import { useToast } from '../../context/ToastContext'
import { DishType } from '../OrderedDishesListCard/OrderedDishesListCard'
import {
  addCommentToProduct,
  updateProductComment,
  removeProductComment,
} from '../../redux/reducers/claims/claimsSlice'
import { useMediaQuery } from 'react-responsive'
const CreateCommentModal = ({
  onClose,
  selectedProduct,
}: {
  onClose: () => void
  selectedProduct: DishType
}) => {
  const dispatch = useAppDispatch()
  const { showSuccess, showError } = useToast()
  const isMobile = useMediaQuery({ query: '(max-width: 767px)' })

  const createCommentHandler = (values: { comment: string }) => {
    try {
      if (selectedProduct?.comment) {
        dispatch(
          updateProductComment({
            productId: selectedProduct.id,
            comment: values.comment,
          }),
        )
        showSuccess('Комментарий успешно изменен')
      } else {
        dispatch(
          addCommentToProduct({
            productId: selectedProduct.id,
            comment: values.comment,
          }),
        )
        showSuccess('Комментарий успешно создан')
      }
      onClose()
    } catch (error) {
      showError('Произошла ошибка при работе с комментарием')
    }
  }

  const handleDeleteComment = () => {
    try {
      dispatch(
        removeProductComment({
          productId: selectedProduct.id,
        }),
      )
      onClose()
      showSuccess('Комментарий успешно удален')
    } catch (error) {
      showError('Произошла ошибка при удалении комментария')
    }
  }
  return (
    <div className={styles.createComment}>
      <div className={styles.titleBlock}>
        <ModalHeader
          title={selectedProduct?.comment ? 'Изменение комментария' : 'Создание комментария'}
          onClickHandler={onClose}
        />
      </div>
      <div className={styles.form}>
        <Formik
          enableReinitialize
          initialValues={{
            comment: selectedProduct?.comment ?? '',
          }}
          onSubmit={(values) => createCommentHandler(values)}
        >
          {(props) => {
            const {
              values,

              handleChange,
              handleBlur,
            } = props
            return (
              <Form className={styles.commentForm}>
                <div className={styles.formGroupItemInput}>
                  <CustomTextArea
                    withoutFile
                    placeholder='Введите'
                    name='comment'
                    required
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.comment}
                  />
                </div>
                <div className={styles.footerContainer}>
                  {selectedProduct?.comment && (
                    <CustomButton
                      iconSrc={IconTrashRed}
                      className={styles.deleteBtn}
                      title={isMobile ? '' : 'Удалить комментарий'}
                      type='button'
                      onClick={handleDeleteComment}
                    />
                  )}
                  <CustomButton
                    className={styles.submitBtn}
                    title={selectedProduct?.comment ? 'Изменить' : 'Добавить'}
                    disabled={!values.comment}
                    type='submit'
                  />
                </div>
              </Form>
            )
          }}
        </Formik>
      </div>
    </div>
  )
}

export default CreateCommentModal
